import React, { SetStateAction } from 'react';

import * as S from './styles';
import Modal from 'components/Modal';
import { ScreenStaticsType } from 'types/SreenStaticsType';
import InovationForm from './Forms/InovationForm';
import CampaignForm from './Forms/CampaignForm';
import BlackFridayForm from './Forms/BlackFridayForm';

type FormSreenStaticsProps = {
	typeForm: ScreenStaticsType;
	setTypeForm: React.Dispatch<SetStateAction<ScreenStaticsType>>;
	isOpen: boolean;
	setIsOpen: React.Dispatch<SetStateAction<boolean>>;
};

export default function FormSreenStatics({
	typeForm,
	isOpen,
	setIsOpen,
	setTypeForm
}: FormSreenStaticsProps) {
	function resetStatesComp() {
		setTypeForm('');
		setIsOpen(false);
	}

	function returnFormByType() {
		switch (typeForm) {
			case 'campaign':
				return <CampaignForm closeModal={resetStatesComp} />;
			case 'inovation':
				return <InovationForm closeModal={resetStatesComp} />;
			case 'blackFriday':
				return <BlackFridayForm closeModal={resetStatesComp} />;
			default:
				return (
					<S.errorForm>
						<p>Formulário não encontrado</p>
					</S.errorForm>
				);
		}
	}

	function returnNameForm() {
		switch (typeForm) {
			case 'campaign':
				return 'Campanha';
			case 'inovation':
				return 'Inovação';
			case 'blackFriday':
				return 'Black friday';
			default:
				return 'Formulário';
		}
	}

	return (
		<Modal
			isOpenProps={isOpen}
			setIsOpenModal={() => {
				setIsOpen((value) => !value);
				resetStatesComp();
			}}
			title={returnNameForm()}
			buttonClose={false}
		>
			{returnFormByType()}
		</Modal>
	);
}
